import React, { memo, SVGProps } from 'react'

export const MoonFull = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.70401 11.798C4.70401 16.1407 8.22607 19.6514 12.5574 19.6514L12.546 19.64C16.4214 19.64 19.6357 16.8246 20.274 13.1316C19.1684 14.0434 17.7436 14.5906 16.1934 14.5906C12.6372 14.5906 9.75343 11.7068 9.75343 8.15055C9.75343 6.60039 10.3005 5.187 11.2124 4.06998C7.51938 4.70828 4.70401 7.92258 4.70401 11.798Z"
      fill="currentColor"
    />
  </svg>
))
